import React from 'react';
import type { ActivityDayGroup as ActivityDayGroupType } from '../../utils/activityAdapters';

interface ActivityDayGroupProps {
  group: ActivityDayGroupType;
  children: React.ReactNode;
}

/**
 * ActivityDayGroup Component
 *
 * Groups activities by day with a sticky header showing the day label.
 * - "Aujourd'hui"
 * - "Hier"
 * - "Lundi 23 décembre 2024"
 */
export const ActivityDayGroup: React.FC<ActivityDayGroupProps> = ({
  group,
  children,
}) => {
  return (
    <div className="activity-day-group">
      <div className="activity-day-group-header">
        <span className="activity-day-group-label">{group.label}</span>
      </div>
      <div className="activity-day-group-items">
        {children}
      </div>
    </div>
  );
};

export default ActivityDayGroup;
